export default __webpack_public_path__ + "static/media/slim.b2891734.webp";